import * as React from "react";
import { FileUploadSection } from "../../generic/fileUploadSection";
import pdf_icon from "../../../../assets/images/pdf_icon.png";
import { getWetSignature } from "../../../service/generic/otherApi";
import { GetDepositoryDetails } from "../../../service/serviceRequest/srApiService";
export interface IKRADetails {
  kraDetails?: {};
  setKraDetails?: any;
  hidePhoto?: boolean;
}
export const KRADocumentUploadForm = (props: IKRADetails) => {
  const [kraDetails, setKraDetails] = React.useState<any>({
    webSign: {},
    panCard: {},
    photo: {},
  });
  const [wetSignContent, setWetSignContent] = React.useState<any>()
  const [wetSignName, setWetSignName] = React.useState<string>("")

  const getFileType = (type?: any) => {
    let fileType: string = "";
    switch (type) {
      case "webSign":
        fileType = "Wetsign";
        break;
      case "panCard":
        fileType = "PAN";
        break;
      case "photo":
        fileType = "ProfilePhoto";
        break;
      default:
        break;
    }
    return fileType;
  };
  React.useEffect(()=>{
    getWetSign();
  },[])
  React.useEffect(() => {
    props.setKraDetails(kraDetails);
  }, [kraDetails]);
  React.useEffect(() => {
    handleSubmitForDocument(wetSignContent, "webSign");
  },[wetSignContent,wetSignName])
  const getDepositoryDet = async () => {
      const resp = await GetDepositoryDetails();

      if (resp && resp.dPIdField && resp.dPAccountNumberField) {
        return resp.dPIdField + resp.dPAccountNumberField;
      } else {
        return "None";
      }
  };
  const getWetSign = async () => {
    let dpId = await getDepositoryDet();
    if(dpId) {
    let resp = await getWetSignature(dpId);
      if(resp?.result[0].DocContent) {
        setWetSignContent(resp?.result[0].DocContent);
        setWetSignName(resp?.result[0].AttachFileName);
      }
    }
  }
  
  const handleSubmitForDocument = (fileDetails: any, type?: any) => {
    let fileObj: any;
    if (fileDetails && ( (wetSignName && wetSignContent) || (fileDetails.docFile && fileDetails.base64Data))) {
      let imgSrc = "";
      let fileContent = "";
      let imgSrcWetSign = "";
      let fileExtension = "";
      if (fileDetails?.docFile && fileDetails.docFile.includes(".")) {
        fileExtension = fileDetails.docFile.split(".").pop()?.toLowerCase() || "";
      }
      if (fileExtension !== "pdf" && getFileType(type) !== "Wetsign") {
        imgSrc = fileDetails.base64Data;
      }
      if(wetSignContent && getFileType(type) === "Wetsign") {
        imgSrcWetSign = wetSignContent;
        fileContent = fileDetails;
      } 
      if(getFileType(type) === "Wetsign" && wetSignName) {
        fileObj = {
          ["fileName"]: (wetSignName),
          ["fileData"]: fileContent,
          ["imgSrc"]: imgSrcWetSign,
          ["documentTypeName"]: getFileType(type),
        };
      }
      else {
        fileObj = {
          ["fileName"]: fileDetails.docFile,
          ["fileData"]: fileDetails?.base64Data?.split(",")[1],
          ["imgSrc"]: imgSrc,
          ["documentTypeName"]: getFileType(type),
        };
      }
      setKraDetails({
        ...kraDetails,
        [`${type}`]: fileObj ? fileObj : {},
      });

    }
  };

  return (
    <>
     { wetSignContent ? <>
         <p className="help-text red" style={{ lineHeight: "1.5"}}>Wet Signature provided at the
         time of account opening/subsequent modifications will be fetched</p>
     </>
     : <div className="custom-row permantAddress--row">
        <p className="ei-text">Signature (Max size 1Mb)</p>
        <FileUploadSection
          disableCross={false}
          fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
          onSubmit={(data: any) => {
            handleSubmitForDocument(data, "webSign");
          }}
          fileSize={1048576}//1MB size
          crop={true}
        />
        {!(
          kraDetails &&
          kraDetails["webSign"] &&
          kraDetails["webSign"].fileName &&
          kraDetails["webSign"].fileData
        ) && (
          <p className="text-indicator small--text-indicator noSpaceIndicator fileUploadIndicator">
            Please upload the photo of your signature on white paper with blue/black ink
          </p>
        )}
      </div>}
      <div className="custom-row permantAddress--row pan-card-kra">
        <p className="ei-text">PAN card copy(Max size 1Mb)</p>
        <FileUploadSection
          disableCross={false}
          fileType={["pdf", "jpg", "jpeg", "tif", "tiff"]}
          onSubmit={(data: any) => {
            handleSubmitForDocument(data, "panCard");
          }}
          fileSize={1048576}//1MB size
        />
        {!(
          kraDetails &&
          kraDetails["panCard"] &&
          kraDetails["panCard"].fileName &&
          kraDetails["panCard"].fileData
        ) && (
          <p className="text-indicator small--text-indicator noSpaceIndicator fileUploadIndicator">
            Please upload the colour image of document directly taken from the original document
          </p>
        )}
      </div>
      {!props?.hidePhoto && (
        <div className="custom-row permantAddress--row pan-card-kra">
          <p className="ei-text">Photo(Max size 1Mb)</p>
          <FileUploadSection
            disableCross={false}
            fileSize={1048576}//1MB size
            fileType={["jpg", "jpeg"]}
            onSubmit={(data: any) => {
              handleSubmitForDocument(data, "photo");
            }}
          />
          {!(
            kraDetails &&
            kraDetails["photo"] &&
            kraDetails["photo"].fileName &&
            kraDetails["photo"].fileData
          ) && (
            <p className="text-indicator small--text-indicator noSpaceIndicator fileUploadIndicator">
              Please upload clear coloured photo
            </p>
          )}
        </div>
      )}
    </>
  );
};
export const ViewKRADocuments = (props: any) => {
  return (
    <>
      <label className="field-subHead bold-text field-subHead-corr-address">
        {props.title}
      </label>
      <span>
        <div
          className={
            !props.document.imgSrc
              ? "display-flex field-subHead"
              : "display-flex field-subHead"
          }
        >
          {props.document.imgSrc ? (
            <img
              src={props.document.imgSrc}
              height="50px"
              width="40px"
              className="ml05"
            />
          ) : (
            <img src={pdf_icon} height="50px" width="50px" />
          )}
          <p className={"bankcheckbox-left"}>{props.document.fileName}</p>
        </div>
      </span>
    </>
  );
};